import { render, staticRenderFns } from "./InstallSheetIOS.vue?vue&type=template&id=19c6c454&"
import script from "./InstallSheetIOS.vue?vue&type=script&lang=js&"
export * from "./InstallSheetIOS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports